import { render, staticRenderFns } from "./ProductPricesModal.vue?vue&type=template&id=7df18ec3&scoped=true"
import script from "./ProductPricesModal.vue?vue&type=script&lang=js"
export * from "./ProductPricesModal.vue?vue&type=script&lang=js"
import style0 from "./ProductPricesModal.vue?vue&type=style&index=0&id=7df18ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df18ec3",
  null
  
)

export default component.exports